const timeToDate = (time) => {
  const [hours, minutes] = time.split(':');
  const today = new Date();

  return new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDay(),
    hours,
    minutes,
    0,
  );
};

const formatTime = (time) => (
  new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(
    timeToDate(time),
  )
);

export const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];

export const shouldDisplaySeparateDays = (hours) => {
  const mondayInterval = hours.monday.openIntervals;

  return weekDays.some((day) => {
    if (hours[day].isClosed) return true;

    return hours[day].openIntervals[0].start !== mondayInterval[0].start
    || hours[day].openIntervals[0].end !== mondayInterval[0].end;
  });
};

export const getTime = ({ openIntervals, isClosed }) => {
  if (isClosed) {
    return 'Closed';
  }

  const [hours] = openIntervals;
  const { start, end } = hours;

  return `${formatTime(start)} - ${formatTime(end)}`;
};
